// Tour utility functions
import axios from 'axios';

export const markTourSeenOnServer = async () => {
  const token = localStorage.getItem('token');
  if (!token) return;
  try {
    await axios.patch(
      '/api/users/me/has-seen-tour',
      { has_seen_tour: true },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  } catch (e) {
    // non-critical — localStorage is the fallback
    console.error('Failed to mark tour seen on server', e);
  }
};

export const TOUR_STORAGE_KEY = 'tourCompleted';
export const TOUR_DATE_KEY = 'tourCompletedDate';

/**
 * Check if the user has completed the tour
 * @returns {boolean} True if tour has been completed
 */
export const hasCompletedTour = () => {
  return localStorage.getItem(TOUR_STORAGE_KEY) === 'true';
};

/**
 * Mark the tour as completed
 */
export const markTourCompleted = () => {
  localStorage.setItem(TOUR_STORAGE_KEY, 'true');
  localStorage.setItem(TOUR_DATE_KEY, new Date().toISOString());
};

/**
 * Reset tour completion status (useful for testing)
 */
export const resetTourCompletion = () => {
  localStorage.removeItem(TOUR_STORAGE_KEY);
  localStorage.removeItem(TOUR_DATE_KEY);
};

/**
 * Get the date when the tour was completed
 * @returns {Date|null} Date of completion or null if not completed
 */
export const getTourCompletionDate = () => {
  const dateString = localStorage.getItem(TOUR_DATE_KEY);
  return dateString ? new Date(dateString) : null;
};

/**
 * Check if the tour was completed recently (within last 7 days)
 * @returns {boolean} True if completed recently
 */
export const isTourRecentlyCompleted = () => {
  const completionDate = getTourCompletionDate();
  if (!completionDate) return false;
  
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
  
  return completionDate > sevenDaysAgo;
};

/**
 * Get tour completion status for display
 * @returns {object} Status object with completion info
 */
export const getTourStatus = () => {
  const completed = hasCompletedTour();
  const completionDate = getTourCompletionDate();
  const recent = isTourRecentlyCompleted();
  
  return {
    completed,
    completionDate,
    recent,
    daysSinceCompletion: completed && completionDate 
      ? Math.floor((new Date() - completionDate) / (1000 * 60 * 60 * 24))
      : null
  };
};
